<template>
    <div class="pbl-panel">
        <div class="left-col">
            <div class="input-wrapper">
                <input
                    v-model="plan"
                    class="input"
                    placeholder="Plan"
                    @keydown.enter="onEnter"
                >
                <span class="char">-</span>
                <input
                    v-model="block"
                    class="input"
                    placeholder="Block"
                    @keydown.enter="onEnter"
                >
                <span class="char">-</span>
                <input
                    v-model="lot"
                    class="input"
                    placeholder="Lot"
                    @keydown.enter="onEnter"
                >
                <span
                    v-if="isClearable"
                    class="mdi mdi-close cursor-pointer"
                    @click="clearForm"
                />
                <span
                    v-else
                    class="mdi mdi-magnify"
                    @click="onEnter"
                />
            </div>
            <ul class="instructions">
                <li>
                    <span class="field"><strong>Plan</strong></span>
                    <span class="desc">(7-character value)</span>
                </li>
                <li>
                    <span class="field"><strong class="optional">Block</strong></span>
                    <span class="desc">Optional: (4-character value)</span>
                </li>
                <li>
                    <span class="field"><strong class="optional">Lot</strong></span>
                    <span class="desc">Optional: (6-character value)</span>
                </li>
            </ul>
        </div>
        <div class="right-col">
            <div class="examples">
                <h3 class="title">
                    Examples
                </h3>
                <ul class="list">
                    <li>
                        <span class="plan">Plan: <span class="value">0213865</span></span>
                        <span class="blok">Block:</span>
                        <span class="lot">Lot:</span>
                    </li>
                    <li>
                        <span class="plan">Plan: <span class="value">8520447</span></span>
                        <span class="blok">Block: <span class="value">75</span></span>
                        <span class="lot">Lot: <span class="value">1A</span></span>
                    </li>
                    <li>
                        <span class="plan">Plan: <span class="value">8521234</span></span>
                        <span class="blok">Block:</span>
                        <span class="lot">Lot: <span class="value">14</span></span>
                    </li>
                    <li>
                        <span class="plan">Plan: <span class="value">7922641</span></span>
                        <span class="blok">Block: <span class="value">1</span></span>
                        <span class="lot">Lot:</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';

export default defineComponent({
    name: 'SearchPBLPanel',
    components: {},
    props: {
        handleSearch: {
            type: Function,
            required: true,
        }
    },
    setup(props) {
        const plan = ref('');
        const block = ref('');
        const lot = ref('');
        const isSearching = ref<boolean>(false);

        const isClearable = computed(() => isSearching.value);

        const clearForm = () => {
            plan.value = '';
            block.value = '';
            lot.value = '';
            isSearching.value = false;
        };

        const onEnter = () => {
            if (!plan.value) {
                return;
            }
            isSearching.value = true;

            let query = `${plan.value}`;

            if (block.value) {
                query = `${query}-${block.value}`;
                if (lot.value) {
                    query = `${query}-${lot.value}`;
                }
            }

            clearForm();
            props.handleSearch(query);
        };

        return {
            plan,
            block,
            lot,
            isClearable,
            clearForm,
            onEnter
        };
    }
});
</script>

<style lang="postcss" scoped>
.pbl-panel{
    @apply flex flex-row flex-wrap w-full p-4 bg-grey-200 overflow-hidden;

    .left-col {
        @apply w-3/5;
    }

    .right-col {
        @apply w-2/5;
    }

    .input-wrapper {
        @apply flex items-center w-full mb-4 text-sm;

        .char {
            @apply mx-1;
        }

        .input {
            @apply p-1;
            width: 100px;
        }

        .mdi {
            @apply text-xl ml-2;
            color: #878787;
        }
    }

    .instructions {
        @apply text-xs;

        .field, .desc {
            @apply inline-block w-2/5;
        }

        .desc {
            @apply w-3/5;
        }

        .optional {
            @apply text-grey-300;
        }
    }

    .examples {
        @apply text-xs;

        .title {
            @apply block text-sm font-bold;
        }

        .list {
            .plan,
            .blok,
            .lot {
                @apply inline-block;
            }

            .plan {
                @apply w-1/2;
            }

            .blok {
                @apply w-1/4;
            }

            .lot {
                @apply w-1/4;
            }

            .value {
                @apply text-grey-300;
            }
        }
    }
}
</style>
